/* POPUP */
export const TOGGLE_NOTICE_WRITE = "TOGGLE_NOTICE_WRITE";
export const TOGGLE_NOTICE_POPUP = "TOGGLE_NOTICE_POPUP";